import { useTranslation } from 'react-i18next';
import { cn } from '@lib/utils';
import type { WidgetStep } from './widgetState';

const STEPS: { id: WidgetStep; labelKey: string }[] = [
  { id: 'service', labelKey: 'widget.steps.service' },
  { id: 'staff', labelKey: 'widget.steps.staff' },
  { id: 'datetime', labelKey: 'widget.steps.datetime' },
  { id: 'details', labelKey: 'widget.steps.details' },
  { id: 'confirmation', labelKey: 'widget.steps.confirmation' },
];

interface StepIndicatorProps {
  currentStep: WidgetStep;
}

export function StepIndicator({ currentStep }: StepIndicatorProps) {
  const { t } = useTranslation();
  const currentIndex = STEPS.findIndex((s) => s.id === currentStep);

  return (
    <nav aria-label="Pasos del proceso de reserva" className="mb-6">
      <ol className="flex items-center gap-1">
        {STEPS.map((step, idx) => {
          const isDone = idx < currentIndex;
          const isCurrent = idx === currentIndex;
          return (
            <li key={step.id} className="flex items-center gap-1">
              <div
                className={cn(
                  'flex h-6 w-6 items-center justify-center rounded-full text-xs font-medium',
                  isDone && 'bg-primary text-primary-foreground',
                  isCurrent && 'border-2 border-primary text-primary',
                  !isDone && !isCurrent && 'border border-muted text-muted-foreground',
                )}
                aria-current={isCurrent ? 'step' : undefined}
              >
                {isDone ? '✓' : idx + 1}
              </div>
              <span
                className={cn(
                  'hidden text-xs sm:inline',
                  isCurrent ? 'font-medium text-foreground' : 'text-muted-foreground',
                )}
              >
                {t(step.labelKey)}
              </span>
              {idx < STEPS.length - 1 && (
                <div className="h-px w-4 bg-border" aria-hidden="true" />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
